var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getIsShowAlertDeepResearch
    ? _c("div", { staticClass: "go-chat-alert-area" }, [
        _c(
          "div",
          {
            staticClass: "go-chat-alert-msg",
            staticStyle: { "font-size": "14px !important" },
          },
          [
            _c("ul", [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t("cdHome.t95", {
                      deepResearchRemain: _vm.deepResearchRemain,
                    })
                  )
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.resetDate
                      ? _vm.$t("cdHome.t96", { resetDate: _vm.resetDate })
                      : _vm.$t("cdHome.t97")
                  )
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "go-chat-alert-btn" }, [
          _c(
            "button",
            { staticClass: "btn go-btn-default", attrs: { type: "button" } },
            [
              _c(
                "em",
                {
                  staticClass: "go-text",
                  staticStyle: { display: "flex", "min-width": "77px" },
                  on: { click: _vm.forwardPlanPricing },
                },
                [_vm._v("Ultra " + _vm._s(_vm.$t("cdHome.t98")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn go-btn-icon close", attrs: { type: "button" } },
            [
              _c(
                "span",
                {
                  staticClass: "go-tooltip-area",
                  attrs: {
                    "data-toggle": "tooltip",
                    title: "",
                    "data-original-title": "Close",
                  },
                  on: { click: _vm.hideAlert },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }